import React from 'react';
import { useTranslation } from 'react-i18next';

import { Panel } from '../../Panel/Panel';
import { TextFieldStatic } from './TextFieldStatic/TextFieldStatic';
import { fields, getValue } from './tools';
import { useLanguage } from '../../hooks/useLanguage/useLanguage';

export function FlightCard(props) {
    const { flight = {} } = props;
    const { t: translate } = useTranslation();
    const { isEng } = useLanguage();

    return (
        <Panel title={translate('flightPage.mainFlightInfo')} className="flight-info__panel  flight-info__panel--main">
            <div className="flight-info__inner">
                {fields.map((item, index) => {
                    const { id, label, full } = item;
                    const onClick = id === 'status' ? () => alert(flight['statusName']) : () => {};
                    const value = getValue(props, id, isEng);
                    let className = 'text-field  flight-info__text-field';
                    if (full) {
                        className += '  flight-info__text-field--full';
                    }

                    return value ? (
                        <TextFieldStatic key={index} label={translate(label)} value={value} onClick={onClick} className={className} />
                    ) : (
                        ''
                    );
                })}
            </div>
        </Panel>
    );
}
